import apiService from './apiService';

// 員工管理 API 服務
const staffService = {
  // 取得員工列表
  listStaff: async () => {
    const response = await apiService.apiRequest('get', 'staff');
    return response.data;
  },

  // 新增員工
  addStaff: async (data) => {
    const response = await apiService.apiRequest('post', 'staff', data);
    return response.data;
  },

  // 移除員工
  removeStaff: async (userId) => {
    const response = await apiService.apiRequest('delete', `staff/${userId}`);
    return response.data;
  },

  // 重設員工密碼
  resetPassword: async (userId) => {
    const response = await apiService.apiRequest('post', `staff/${userId}/reset-password`);
    return response.data;
  },

  // 取得員工權限設定
  getPermissions: async () => {
    const response = await apiService.apiRequest('get', 'staff/permissions');
    return response.data;
  },

  // 更新員工權限設定
  updatePermissions: async (permissions) => {
    const response = await apiService.apiRequest('put', 'staff/permissions', permissions);
    return response.data;
  }
};

export default staffService;
